import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

/**
 * Drop-in replacement for MUI <Button> that shows a spinner and disables itself
 * while `loading` is true. Pairs with the `useAsyncCallback` hook.
 *
 * Props beyond `loading` are forwarded to the underlying Button.
 */
export default function SaveButton(props) {
    const { loading, disabled, children, startIcon, sx, ...rest } = props;

    const spinner = (
        <CircularProgress
            size={16}
            thickness={5}
            sx={{ color: 'inherit' }}
        />
    );

    return (
        <Button
            {...rest}
            disabled={loading || disabled}
            startIcon={loading ? spinner : startIcon}
            sx={{ minWidth: 88, ...sx }}
        >
            {children}
        </Button>
    );
}

SaveButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    startIcon: PropTypes.node,
    sx: PropTypes.object,
};
